import { Modifier, EditorState } from 'draft-js';
import { EmojiData } from '../emojiPlugin';

export default function addEmoji(editorState: EditorState, emoji: EmojiData): EditorState {
  const contentStateWithEntity = editorState.getCurrentContent().createEntity('emoji', 'SEGMENTED', {
    emoji,
  });
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

  let emojiReplacedContent = Modifier.replaceText(
    editorState.getCurrentContent(),
    editorState.getSelection(),
    `${emoji.native}`,
    editorState.getCurrentInlineStyle(),
    entityKey
  );

  // insert a space if after emoji is inserted for a smooth writing experience.
  emojiReplacedContent = Modifier.insertText(emojiReplacedContent, emojiReplacedContent.getSelectionAfter(), ' ');

  const newEditorState = EditorState.push(editorState, emojiReplacedContent, 'insert-characters');
  return EditorState.forceSelection(newEditorState, emojiReplacedContent.getSelectionAfter());
}
